<template>
  <div class="or-condition">
    <event-condition
      v-if="type === 'event'"
      v-model="condition"
      ref="condition"
    ></event-condition>
    <div class="user-prop-condition" v-else-if="type === 'user'">
      <span class="label">属性</span>
      <!-- 用户属性面板：支持 todaySelectable -->
      <condition
        v-model="condition"
        :propWidth="150"
        :have-user-prop="true"
        :have-event-env="false"
        :todaySelectable="true"
        ref="condition"
      ></condition>
    </div>
    <new-condition
      v-else-if="type === 'new' || type === 'active'"
      :type="type"
      v-model="condition"
      ref="condition"
    ></new-condition>

    <i class="btn-del cicon-delete-little1" @click="onDel"></i>
  </div>
</template>

<script>
// import ConditionTagGroup from './tagGroup'
import EventCondition from './eventCondition'
import Condition from './condition'
import NewCondition from './newCondition'

export default {
  name: 'orCondition',
  components: {
    NewCondition,
    Condition,
    EventCondition
    // ConditionTagGroup
  },
  props: {
    value: null,
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['event', 'new', 'active', 'user'].includes(value)
      }
    }
  },
  data() {
    let data = {
      condition: null
    }
    if (this.value) {
      data.condition = this.type === 'user' ? this.value.attrs[0] : this.value
    }
    return data
  },
  watch: {
    condition() {
      if (
        JSON.stringify(this.value) !== JSON.stringify(this.condition) &&
        this.condition !== undefined
      ) {
        let result = this.condition
        if (this.type === 'user') {
          result = {
            attrs: [this.condition]
          }
        }
        this.$emit('input', result)
        this.$emit('change', result)
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.condition.validate()
    },
    onDel() {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="sass">
@import "./styles/orCondition"
</style>
